export default commomImport => [{
  path: `account-manager`,
  name: 'AccountManager',
  meta: {
    title: 'store.accountManager'
  },
  //  全部订单
  component: commomImport('store-manager/account-manager')
}];
